// Auto-generated by pipeline
export const firebaseConfig = {
  "authDomain": "armario-perfeito-bdc46.firebaseapp.com",
  "projectId": "armario-perfeito-bdc46",
  "storageBucket": "armario-perfeito-bdc46.firebasestorage.app",
  "messagingSenderId": "768546737986",
  "appId": "1:768546737986:web:e7f2bbf3c38632d91a82db",
  "measurementId": "G-70KDZRVVKG",
  "apiKey": "AIzaSyCaDCKZyDuhFy3Jeh_WZ9djOcZCPAp27cA"
};
